import { useCallback, useEffect } from "react";

import type { RefObject } from "react";

export interface UseClickOutsideProps {
	ref: RefObject<HTMLElement | null>;
	onClickOutside: (e?: Event) => void;
	condition?: boolean;
}

export const useClickOutside = ({ ref, onClickOutside, condition = true }: UseClickOutsideProps) => {
	const handleClickOutside = useCallback(
		(e: Event) => {
			if (condition && ref.current && !ref.current.contains(e.target as Node)) {
				onClickOutside(e);
			}
		},
		[condition, onClickOutside, ref],
	);

	useEffect(() => {
		window.addEventListener("click", handleClickOutside);
		return () => window.removeEventListener("click", handleClickOutside);
	}, [handleClickOutside]);
};
